<template>
  <aha-modal @hide="hideModal()" :title="title_DeclineInvitation">
    <p v-html="content"></p>
    <template #action>
      <aha-button
        variant="danger"
        @click="declineInvitation()"
        has-margin-right
      >
        {{ $i18nPresenter.t("Decline") }}
      </aha-button>
      <aha-link @click="hideModal()">
        <span>{{ $i18nPresenter.t("Cancel") }}</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    handleDecline: {
      type: Function,
      default: () => {},
    },
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      slidesToDelete: [],
      title_DeclineInvitation: this.$i18nPresenter.t('Decline invitation'),
    }
  },
  methods: {
    declineInvitation() {
      if (this.handleDecline) {
        try {
          this.handleDecline()
        } catch (e) {
          throw new Error('') // caught inside parent
        }
        this.hideModal()
      }
    },

    hideModal() {
      this.$emit('hide')
    },
  },
}
</script>
